import { Box } from '@mui/material';

import { HelpButton } from './HelpButton';
import { ProfileButton } from './ProfileButton';

export function TopPanel() {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                px: 4,
                py: 1,
                borderBottom: 1,
                borderColor: 'info.main',
                backgroundColor: 'background.paper',
            }}
            data-testid="topPanel"
            id="topPanel"
        >
            <HelpButton />
            <ProfileButton />
        </Box>
    );
}
